var map = {
	"./commonSettings": 1379,
	"./commonSettings.js": 1379,
	"./development/amazon": 1380,
	"./development/amazon.json": 1380,
	"./development/shopify": 1381,
	"./development/shopify.json": 1381,
	"./local/amazon": 1382,
	"./local/amazon.json": 1382,
	"./local/shopify": 1383,
	"./local/shopify.json": 1383,
	"./production/amazon": 1384,
	"./production/amazon.json": 1384,
	"./production/shopify": 1385,
	"./production/shopify.json": 1385,
	"./test/amazon": 1386,
	"./test/amazon.json": 1386,
	"./test/shopify": 1387,
	"./test/shopify.json": 1387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1590;